import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { DOCUMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/documents/")({
  component: () => <DeptContentList cfg={DOCUMENTS} />,
});
